export const SALES_ECONOMICS_ACTIVITY_CONCURRENCY = 4;
export const SALES_ECONOMICS_EMAIL_COLUMNS = "deal_id,provider,provider_id,timestamp,sender_email:data->from->>email";
export const SALES_ECONOMICS_MEETING_COLUMNS = "deal_id,provider,provider_id,started_at,ended_at,attendee_emails:provider_data->properties->>hs_all_attendee_emails,seller_participant_count:provider_data->properties->>revelate_seller_participant_count";

export function normalizeSalesEconomicsProviderData(
  providerData: unknown,
): string {
  return typeof providerData === "string"
    ? providerData
    : JSON.stringify(providerData ?? {});
}

export const SALES_ECONOMICS_DEAL_COLUMNS = `
  id, company_id, created_at, closed_at, is_closed, is_won, is_lost,
  name, pipeline, provider, provider_id, provider_owner_id, updated_at,
  value, currency_id, currency_code, deal_type, provider_data, users
`;
